// TODO: refactor jQuery --> ES
export default class ExpressPlusImageUpload {
	constructor(app) {
		this.app = app;

		$(document).on("file_uploaded", ".js-fileuploadfield", function () {
			let gthis = $(this);
			let gtype = $(this).closest(".js-var-image-upload").data("subtype");
			$(".js-file-upload-preview").hide();
			let akey = $(this).data("key");
			let aimg = $(this).parent().find("input[name='image.0.key']").val();
			$.ajax({
				url: "/" + gtype + "/imageupload?key=" + akey + "&img=" + aimg
			}).done(function (data) {
				gthis.closest(".js-vBox-wrap").find(".js-var-image").attr("src", data)
			})
		})

		$(document).on("file_deleted", ".js-fileuploadfield", function () {
			let gthis = $(this);
			let gtype = $(this).closest(".js-var-image-upload").data("subtype");
			$(".js-file-upload-preview").hide();
			let akey = $(this).data("key");
			$.ajax({
				url: "/" + gtype + "/imageupload?key=" + akey
			}).done(function (data) {
				gthis.closest(".js-vBox-wrap").find(".js-var-image").attr("src", data)
			})
		})
	}
}
